import {
  Box,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { ExpandLessRounded, ExpandMoreRounded } from "@mui/icons-material";
import { Fragment, useState } from "react";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme, _params, classes) => ({
  dateFilter: {
    display: "flex",
    alignItems: "center",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    padding: "8px 12px",
    gap: 4,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

export const dateFilterOptions = [
  {
    label: "WoW (Week over Week)",
    value: "wow",
  },
  {
    label: "MoM (Month over Month)",
    value: "last_30_days",
  },
  {
    label: "QoQ (Quarter over Quarter)",
    value: "qoq",
  },
  {
    label: "YoY (Year over Year)",
    value: "yoy",
  },
  {
    label: "All Time",
    value: "all_time",
  },
];

function DateFilter({ dateFilter, onDateFilterChange }) {
  const { classes } = useStyles();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  return (
    <Fragment>
      <Box
        className={classes.dateFilter}
        onClick={(e) => setAnchorEl(e.currentTarget)}>
        <Typography>{dateFilter.label}</Typography>
        {open ? (
          <ExpandLessRounded sx={{ color: theme.palette.action.active }} />
        ) : (
          <ExpandMoreRounded sx={{ color: theme.palette.action.active }} />
        )}
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        slotProps={{ paper: { sx: { borderRadius: 1, mt: 1 } } }}>
        {dateFilterOptions.map((option) => {
          return (
            <MenuItem
              key={option.value}
              onClick={() => {
                onDateFilterChange(option);
                setAnchorEl(null);
              }}>
              {option.label}
            </MenuItem>
          );
        })}
        {/* <CustomRange /> */}
      </Menu>
    </Fragment>

    // <TextField
    //   select
    //   slotProps={{
    //     input: {
    //       style: { borderRadius: 8 },
    //     },
    //   }}
    //   variant="outlined"
    //   size="small"
    //   value={dateFilter}
    //   onChange={(e) => onDateFilterChange(e.target.value)}>
    //   {dateFilterOptions.map((option) => {
    //     return (
    //       <MenuItem key={option.value} value={option.value}>
    //         {option.label}
    //       </MenuItem>
    //     );
    //   })}
    // </TextField>
  );
}

function CustomRange() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  return (
    <Fragment>
      <MenuItem onClick={(prev) => setOpen(!prev)}>
        <Box display="flex" alignItems="center" gap={0.5}>
          <ListItemText>Custom Range</ListItemText>
          {open ? (
            <ExpandLessRounded
              fontSize="small"
              sx={{ color: theme.palette.action.active }}
            />
          ) : (
            <ExpandMoreRounded
              fontSize="small"
              sx={{ color: theme.palette.action.active }}
            />
          )}
        </Box>
      </MenuItem>
    </Fragment>
  );
}

export default DateFilter;
